<template>
  <div class="">
    {{ productName }}
  </div>
</template>

<script>
export default {
  name: "FormChooseMultipleProductInputAnswer",
  props: {
    answer: {}
  },
  data() {
    return {
      productName: ''
    }
  },
  methods: {
    parseObjectString(str) {
      return JSON.parse(
          str
              .trim()
              .replace(/(\d+)\s*:/g, '"$1":')
      );
    },
    async findAnswer() {
      let answer = this.answer.label.split(',')
      let productIds = []
      answer.forEach((item) => {
        let value = this.parseObjectString(item)
        productIds.push(Object.keys(value)[0])
      })
      console.log(productIds)
      let req = await this.$store.dispatch("Product/getProductsWithIds", {products: productIds});
      this.productName = req.data.data.map((item) => {
        return item.name
      }).join(', ')
    }
  },
  async mounted() {
    await this.findAnswer()
  }
}
</script>

<style scoped>

</style>